export const enum commonConstants {
  showSuccessMessage = "SHOW_SUCCESS_MESSAGE",
  showErrorMessage = "SHOW_ERROR_MESSAGE",

  setLoading="SET_LOADING",

  getServicesListRequest = "GET_SERVICES_LIST_REQUEST",
  getServicesListSuccess = "GET_SERVICES_LIST_SUCCESS",
  getServicesListFailure = "GET_SERVICES_LIST_FAILURE",

  getSpecializationsListRequest = "GET_SPECIALIZATIONS_LIST_REQUEST",
  getSpecializationsListSuccess = "GET_SPECIALIZATIONS_LIST_SUCCESS",
  getSpecializationsListFailure = "GET_SPECIALIZATIONS_LIST_FAILURE",

  getDocumentTypesListRequest = "GET_DOCUMENT_TYPES_LIST_REQUEST",
  getDocumentTypesListSuccess = "GET_DOCUMENT_TYPES_LIST_SUCCESS",
  getDocumentTypesListFailure = "GET_DOCUMENT_TYPES_LIST_FAILURE",

  uploadFileRequest = "UPLOAD_FILE_REQUEST",
  uploadFileSuccess = "UPLOAD_FILE_SUCCESS",
  uploadFileFailure = "UPLOAD_FILE_FAILURE",

  removeFileRequest = "REMOVE_FILE_REQUEST",
  removeFileSuccess = "REMOVE_FILE_SUCCESS",
  removeFileFailure = "REMOVE_FILE_FAILURE",

  getRoleRequest = "GET_ROLE_REQUEST",
  getRoleSuccess = "GET_ROLE_SUCCESS",
  getRoleFailure = "GET_ROLE_FAILURE",

  getStudioListRequest = "GET_STUDIO_LIST_REQUEST",
  getStudioListSuccess = "GET_STUDIO_LIST_SUCCESS",
  getStudioListFailure = "GET_STUDIO_LIST_FAILURE",

  getAlbumTemplatesRequest = "GET_ALBUM_TEMPLATES_REQUEST",
  getAlbumTemplatesSuccess = "GET_ALBUM_TEMPLATES_SUCCESS",
  getAlbumTemplatesFailure = "GET_ALBUM_TEMPLATES_FAILURE",
  getUserNotificationRequest = "GET_USER_NOTIFICATION_REQUEST",
  getUserNotificationSuccess = "GET_USER_NOTIFICATION_SUCCESS",
  getUserNotificationFailure = "GET_USER_NOTIFICATION_FAILURE",

  getNotificationCountRequest = "GET_NOTIFICATION_COUNT_REQUEST",
  getNotificationCountSuccess = "GET_NOTIFICATION_COUNT_SUCCESS",
  getNotificationCountFailure = "GET_NOTIFICATION_COUNT_FAILURE",

  listNotificationsRequest = "LIST_NOTIFICATIONS_REQUEST",
  listNotificationsSuccess = "LIST_NOTIFICATIONS_SUCCESS",
  listNotificationsFailure = "LIST_NOTIFICATIONS_FAILURE",

  markAllReadRequest = "MARK_ALL_READ_REQUEST",
  markAllReadSuccess = "MARK_ALL_READ_SUCCESS",
  markAllReadFailure = "MARK_ALL_READ_FAILURE",

  markOneReadRequest = "MARK_ONE_READ_REQUEST",
  markOneReadSuccess = "MARK_ONE_READ_SUCCESS",
  markOneReadFailure = "MARK_ONE_READ_FAILURE",

  fetchNotificationSettingsRequest = "FETCH_NOTIFICATION_SETTINGS_REQUEST",
  fetchNotificationSettingsSuccess = "FETCH_NOTIFICATION_SETTINGS_SUCCESS",
  fetchNotificationSettingsFailure = "FETCH_NOTIFICATION_SETTINGS_FAILURE",

  updateNotificationSettingsRequest = "UPDATE_NOTIFICATION_SETTINGS_REQUEST",
  updateNotificationSettingsSuccess = "UPDATE_NOTIFICATION_SETTINGS_SUCCESS",
  updateNotificationSettingsFailure = "UPDATE_NOTIFICATION_SETTINGS_FAILURE",

  contactUsRequest = "CONTACT_US_REQUEST",
  contactUsSuccess = "CONTACT_US_SUCCESS",
  contactUsFailure = "CONTACT_US_FAILURE",

  getRoutesListRequest = "GET_ROUTES_LIST_REQUEST",
  getRoutesListSuccess = "GET_ROUTES_LIST_SUCCESS",
  getRoutesListFailure = "GET_ROUTES_LIST_FAILURE",

  getAccessibleRoutesListRequest = "GET_ACCESSIBLE_ROUTES_LIST_REQUEST",
  getAccessibleRoutesListSuccess = "GET_ACCESSIBLE_ROUTES_LIST_SUCCESS",
  getAccessibleRoutesListFailure = "GET_ACCESSIBLE_ROUTES_LIST_FAILURE",
  
  viewNotificationRequest = "VIEW_NOTIFICATION_REQUEST",
  viewNotificationSuccess = "VIEW_NOTIFICATION_SUCCESS",
  viewNotificationFailure = "VIEW_NOTIFICATION_FAILURE",

  kycNameCheckRequest = "KYC_NAME_CHECK_REQUEST",
  kycNameCheckSuccess = "KYC_NAME_CHECK_SUCCESS",
  kycNameCheckFailure = "KYC_NAME_CHECK_FAILURE",
  
  generateSessionSasRequest = "GENERATE_SESSION_SAS_REQUEST",
  generateSessionSasSuccess = "GENERATE_SESSION_SAS_SUCCESS",
  generateSessionSasFailure = "GENERATE_SESSION_SAS_FAILURE",

};

